export function actionAddBill(bill) {
    return {
      type: 'ADD_TOTAL_BILL',
      payload:bill
    }
  }